export default function useGetExportColumns() {
  const getExportColumns = (mergedColumns, onlyVisible = true) =>
    (Array.isArray(mergedColumns) ? mergedColumns.filter((x) => x.ColField !== 'Action' && (x.Visible || !onlyVisible)) : []);

  return getExportColumns;
}
